import { SET_ASSESSMENT_DATA } from "./action.types";

export const setAssessmentList = (payload) => ({
  type: SET_ASSESSMENT_DATA,
  payload,
});
